import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../../app/guards'
import { taxRatesQueryOptions } from '../../../features/finance/queries'
import { PURCHASING_ACCESS } from '../../../features/purchasing/access'
import { NewSupplierReturnPage } from '../../../features/purchasing/return-pages'
import { newReturnSearchSchema } from '../../../features/purchasing/search'
import { salesSettingsQueryOptions } from '../../../features/sales/queries'

export const Route = createFileRoute('/_app/supplier-returns/new')({
  staticData: { crumb: 'supplierReturnNew' },
  validateSearch: newReturnSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, PURCHASING_ACCESS.supplierReturn),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(salesSettingsQueryOptions),
      context.queryClient.ensureQueryData(taxRatesQueryOptions),
    ])
  },
  component: NewSupplierReturnPage,
})
